/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

const cashIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-freelance.svg";
const buildingIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-nonfinance.svg";
const calendarIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-calendar.svg";
const digitalIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-digitize.png";
const thumbsUpIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-other.svg";
const coinIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-sales.png";
const priceBagIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-finance.png";


const reasonToJoinFPD = {
  question: "how can Wealthy help you succeed?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "reason_to_join",
  options: [
    {
      icon: coinIcon,
      title: "by allowing me to widen my range of financial products",
      subtitle: "",
      next: null,
      value: "second income source"
    },
    {
      icon: thumbsUpIcon,
      title: "by giving me better rates of commission",
      subtitle: "",
      next: null,
      value: "better rates"
    },
    {
      icon: digitalIcon,
      title: "by letting me digitise my existing financial services business",
      subtitle: "",
      next: null,
      value: "digitize existing financial service business"
    }
  ]
};

const reasonToJoinNFB = {
  question: "how can Wealthy help you succeed?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "reason_to_join",
  options: [
    {
      icon: coinIcon,
      title: "by helping me establish a second source of income",
      subtitle: "",
      next: null,
      value: "second income source"
    },
    {
      icon: priceBagIcon,
      title: "by allowing me to start my own finance business",
      subtitle: "",
      next: null,
      value: "start own finance business"
    },
    {
      icon: thumbsUpIcon,
      title: "not sure, just exploring",
      subtitle: "",
      next: null,
      value: "exploring"
    }
  ]
};

const businessTieUps = {
  question: "do you have any business tie-ups?",
  description: "you can choose more than one answer",
  answerKey: "business_tie_ups",
  isCheckbox: true,
  options: [
    {
      title: "nj wealth",
      subtitle: "",
      value: "nj wealth",
      next: reasonToJoinFPD
    },
    {
      title: "mintpro",
      subtitle: "",
      value: "mintpro",
      next: reasonToJoinFPD
    },
    {
      title: "lic",
      subtitle: "",
      value: "lic",
      next: reasonToJoinFPD
    },
    {
      title: "other insurance",
      subtitle: "",
      value: "other insurance",
      next: reasonToJoinFPD
    },
    {
      title: "prudent",
      subtitle: "",
      value: "prudent",
      next: reasonToJoinFPD
    },
    {
      title: "others",
      subtitle: "",
      value: "others",
      next: reasonToJoinFPD
    },
    {
      title: "no tie-ups",
      subtitle: "",
      value: "none",
      next: reasonToJoinFPD
    }
  ]
};

const businessStartedAt = {
  question: "when did you start doing business independently?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "business_start_duration",
  options: [
    {
      icon: calendarIcon,
      title: "less than 6 months",
      value: "<6m",
      next: businessTieUps
    },
    {
      icon: calendarIcon,
      title: "6 months - 1 year",
      value: "6m-1y",
      next: businessTieUps
    },
    {
      icon: calendarIcon,
      title: "more than a year",
      value: ">1y",
      next: businessTieUps
    }
  ]
};

const ownBusinessQuestions = {
  icon: cashIcon,
  title: "i own a business",
  subtitle: "i have already started my business",
  value: "OB",
  next: {
    question: "what type of business?",
    answerKey: "product_experience",
    description:
        "this will help us know you better as a wealth partner",
    options: [
      {
        icon: buildingIcon,
        title: "financial product distribution",
        subtitle: "Insurance, MFs, Loans and others",
        value: "FPD",
        next: businessStartedAt
      },
      {
        icon: cashIcon,
        title: "non finance business",
        subtitle: "",
        value: "NFB",
        next: reasonToJoinNFB
      }
    ]
  }
};

export default ownBusinessQuestions;
